<template lang="pug">
  div
    b-form(@submit.prevent="handleSubmit")
      b-alert(v-if="!result" show variant="info")
        | Se ejecutará el webhook de cambio de estado para
        b  {{ deliveryIds.length }}
        |  envíos seleccionados.
      b-alert(v-if="result" show :variant="result.error ? 'danger' : 'success'")
        div(v-if="result.error")
          p.mb-1 ❌ {{ result.error }}
        div(v-else)
          p.mb-1 ✅ {{ result.message }}
          p.mb-1(v-if="result.packageIds") 📦 Packages procesados: {{ result.packageIds.join(', ') }}
          p.mb-1(v-if="result.notFound !== undefined")
            small ⚠️ {{ result.notFound }} de {{ deliveryIds.length }} envíos no fueron encontrados
      .d-flex.justify-content-end
        b-button(
          type="submit"
          variant="primary"
          :disabled="loading || !!result"
        )
          span(v-if="loading")
            b-spinner(small)
            |  Ejecutando...
          span(v-else) Ejecutar Webhook
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    deliveryIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      result: null
    }
  },
  methods: {
    ...mapActions(['bulkTriggerWebhook']),
    async handleSubmit() {
      this.loading = true
      this.result = null
      try {
        const response = await this.bulkTriggerWebhook({ deliveryIds: this.deliveryIds })
        this.result = response.data
        this.$emit('done')
      } catch (err) {
        this.result = {
          error: err.response?.data?.message || 'Error al ejecutar el webhook'
        }
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    deliveryIds() {
      this.result = null
    }
  }
}
</script>
